import { render } from "./ShowMore.vue?vue&type=template&id=0fc3e2c1&ts=true"
import script from "./ShowMore.vue?vue&type=script&lang=ts"
export * from "./ShowMore.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__